jQuery(function($) {

  // ---- IMPORTANT ---- //
  /* This code is running on both PG and UBER(CASEL main site)
    CASEL specific functionality will be marked as such
  */

  const update_total = $('#JS-filter-btn, #JS-filter-btn-dynamic');
  const total_viewed = $('#total-viewed');

  // Grab all checkboxes and sort in to groups base on shared name
  const filter_checkboxes = $('.initial-filter');
  let checkbox_group_names = [];
  filter_checkboxes.each(function() {
    if (jQuery.inArray($(this).attr('name'), checkbox_group_names) === -1) {
      checkbox_group_names.push($(this).attr('name'));
    }
  });

  // Add sticky header to list view
  $('body').scroll(function() {
    if ($('#JS-result-info').length && $(window).width() > 768) {
      if ($(window).scrollTop() >= $('#JS-result-info').offset().top - 10) {
        $('#JS-result-info').addClass('result-info-following');
      }
      else {
        $('#JS-result-info').removeClass('result-info-following');
      }
    }

    if ($('#JS-result-info').length && $(window).width() <= 768) {
      if ($(window).scrollTop() >= $('#filter-wrap').position().top) {
        $('#filter-wrap').addClass('filter-wrap-sticky-following');
        if ($(window).width() < 440) {
          $('.sticky-bottom').css('display', 'block');
          $('.sticky-bottom').css('textAlign', 'center');
        }
        else {
          $('.sticky-bottom').css('display', 'flex');
          $('.sticky-bottom').css('textAlign', 'left');
        }
      }
    }
  });

  // Function is called everytime a checkbox is clicked
  // Updates shown/hidden elements
  // Sort into groups
  filter_checkboxes.change(function(e) {
    let filtered_results = $('#JS-program-results .list-item');
    e.preventDefault();
    if ($('.initial-filter:checked').length === 0) {
      $('.list-item').show();
    }
    else {
      // Read Selectetd Filters
      let selectedFilters = {};
      filter_checkboxes.filter(':checked').each(function() {
        if (!selectedFilters.hasOwnProperty(this.name)) {
          selectedFilters[this.name] = [];
        }
        selectedFilters[this.name].push(this.value);
      });

      $.each(selectedFilters, function(name, filter_values) {

        // filter each .list-item element
        filtered_results = filtered_results.filter(function() {

          var matched = false,
              current_filter_values = $(this).data('category').split(' ');

          // loop over each category value in the current .list-item data-category
          $.each(current_filter_values, function(_, current_filter_value) {

            // if the current category exists in the selected filters array
            // set matched to true, and stop looping. as we're ORing in each
            // set of filters, we only need to match once

            if ($.inArray(current_filter_value, filter_values) !== -1) {
              matched = true;
              return false;
            }
          });

          // if matched is true the current .list-item element is returned
          return matched;
        });

        // Hide excluded results, show qualifying elements
        $('.list-item').hide().filter(filtered_results).show();
      });
      updateFilterTotal();
    }
  });

  // Set initial checkbox counter
  $(window).on('load', function() {
    let total_checked_filters = 0;

    $('.filter-wrap .accordion-outer').each(function() {
      let total_filters = $(this).find('.checked').length;
      if (total_filters === 0) {
        total_filters = $(this).find(':checked').length;
      }

      total_checked_filters = total_checked_filters + total_filters;

      let counter = $(this).parent().find('.filter-counter');
      if (total_filters > 0) {
        counter.addClass('active');
        counter.text(total_filters);
      }
      if (total_filters === 0) {
        counter.removeClass('active');
      }

      if (total_checked_filters > 0) {
        update_total.find('span').text('(' + total_checked_filters + ')');
      }
      else {
        update_total.find('span').text('');
      }
    });
  });

  // Update result message
  function updateFilterTotal() {
    let total_visible = 0;
    setTimeout(function() {
      $('#JS-program-results .list-item').each(function() {
        if ($(this).css('display') !== 'none' && $(this).css('height') !== '0px') {
          total_visible ++;
        }
      });
      total_viewed.text(total_visible);
      if (total_visible === 0) {
        $('.results-empty').show();
      }
      else {
        $('.results-empty').hide();
      }
    }, 300);
  }

  // Clear filters and reset counters
  function clearFilters() {
    $('input[type="date"]').val(null);
    $('input[type="text"]').val('');
    $('input[class^="show"]').prop('checked', false).trigger('change');
    $('.filter-wrap .checkbox').removeClass('checked');
    update_total.find('span').text('');
    $('.filter-counter.active').removeClass('active').text('');
    updateFilterTotal();
    $('.list-item').show();
    $('.filter-wrap .accordion-outer input:checked').prop('checked', false);
  }

  // Function limits amount selecatable programs and updates information at top of the page
  function limitSelection() {
    let checked = $('.snapshot-utility input[type=checkbox]:checked').length;
    $('#JS-submit-programs span').text(checked);

    if (checked === 3) {
      $('.snapshot-utility input[type=checkbox]').not(':checked').attr('disabled', true);
    }
    else {
      $('.snapshot-utility input[type=checkbox]').not(':checked').attr('disabled', false);
    }
  }

  // Accordion functionality with in table
  $('[class^="show"]').change(function() {
    // Total that displays in filter button
    let total_checked_filters = 0;
    $('[for="' + $(this).attr('id') + '"]').toggleClass('checked');
    // Update counters
    $('.filter-wrap .accordion-outer').each(function() {
      let total_filters = $(this).find('.checked').length;
      let counter = $(this).parent().find('.filter-counter');
      counter.text(total_filters);
      total_checked_filters = total_checked_filters + total_filters;
      if (total_filters > 0) {
        counter.addClass('active');
      }
      if (total_filters === 0) {
        counter.removeClass('active');
      }

      if (total_checked_filters > 0) {
        update_total.find('span').text('(' + total_checked_filters + ')');
      }
      else {
        update_total.find('span').text('');
      }
    });
    updateFilterTotal();
  });

  $('[class^="sort"]').change(function() {
    // Update checkbox label
    $('.sort').not($(this)).prop('checked', false);
    $('.filter-wrap .radio').removeClass('checked');
    $('[for="' + $(this).attr('id') + '"]').addClass('checked');
  });

  // Calls to clear filters function
  $('#JS-clear-filters').click(function() {
    clearFilters();
  });

  $('#JS-clear-filter-mobile').click(function() {
    clearFilters();
  });

  $('#JS-clear-programs').click(function() {
    $('.snapshot-utility input[type=checkbox]:checked').click();
  });

  //Limit amount fo selectable programs
  $('.snapshot-utility input[type=checkbox]').on('change', function(e) {
    limitSelection();
  });

  // Call initially to keep track of session
  limitSelection();

  // Set clean arguments for programs selected
  $('#top-results').submit(function(e) {
    let selected = [];
    for (let i = 0; i < $('#JS-program-results input:checked').length; i++) {
      const checkbox = $('#JS-program-results input:checked')[i];
      selected.push(checkbox.value);
    }
    $('#JS-program-select').val(selected.join(','));
  });

  // CASEL UBER SPECIFIC, update checkbox counter for each checked checkbox
  $('.filter-wrap .accordion-outer input').change(function() {
    let total_checked_filters = 0;

    $('.filter-wrap .accordion-outer').each(function() {
      // Check for inputs with in search form (PG)
      let total_filters = $(this).find('.checked').length;
      if (total_filters === 0) {
        total_filters = total_filters = $(this).find('input:checked').length;
      }
      // Check for inputs with in search form (UBER)
      if (total_filters === 0) {
        total_filters = total_filters = $(this).find('input:checked').length;
      }

      // Update counters next to section labels
      let counter = $(this).parent().find('.filter-counter');
      counter.text(total_filters);
      if (total_filters > 0) {
        counter.addClass('active');
      }
      if (total_filters === 0) {
        counter.removeClass('active');
      }

      // Update total filters checked
      total_checked_filters = total_checked_filters + total_filters;

      if (total_checked_filters > 0) {
        update_total.find('span').text('(' + total_checked_filters + ')');
      }
      else {
        update_total.find('span').text('');
      }
    });
  });
  // end CASEL UBER SPECIFIC

});
